import { render, staticRenderFns } from "./guess-dialog.vue?vue&type=template&id=616bfcd8&scoped=true"
import script from "./guess-dialog.vue?vue&type=script&lang=js"
export * from "./guess-dialog.vue?vue&type=script&lang=js"
import style0 from "./guess-dialog.vue?vue&type=style&index=0&id=616bfcd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bfcd8",
  null
  
)

export default component.exports